import Vue from 'vue'

import { appConfig } from './config/otu.conf.js';
Vue.prototype.$appConfig = appConfig;
